module.exports = __webpack_public_path__ + "img/wf-finishing-position-22.5c585eb9.svg";